import React from 'react'
import { Card, Space, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { hexToRGBA } from '../../../../lib/utils'

const { Text } = Typography

const SectionWithBorder = ({ title, children, fitContent, token, icon = faUser }) => {
  return (
    <Card
      title={
        <Space size={12}>
          <div
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '10px',
              backgroundColor: hexToRGBA(token.colorPrimary, 0.1),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <FontAwesomeIcon icon={icon} style={{ color: token.colorPrimary, fontSize: '18px' }} />
          </div>
          <div>
            <Text strong style={{ fontSize: '18px', display: 'block' }}>
              {title}
            </Text>
            <Text type='secondary' style={{ fontSize: '14px' }}>
              Complete all required information
            </Text>
          </div>
        </Space>
      }
      bordered={false}
      style={{
        width: fitContent ? 'fit-content' : '100%',
        borderRadius: '16px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
        background: 'linear-gradient(135deg, #ffffff 0%, #f8fafe 100%)',
        border: `1px solid ${hexToRGBA(token.colorBorder, 0.1)}`,
        marginBottom: '24px'
      }}
      bodyStyle={{ padding: '32px' }}
      headStyle={{
        borderBottom: 'none',
        backgroundColor: 'transparent',
        padding: '24px 32px 0 32px'
      }}
    >
      {children}
    </Card>
  )
}

export default SectionWithBorder
